export const textTheme = {
  sizes: {
    sm: { fontSize: ['xs', 'sm'] },
    md: { fontSize: ['sm', 'md'] },
    lg: { fontSize: ['md', 'lg'] },
  },
  defaultProps: {
    size: 'md',
  },
};
